import { EngagementV1DTO } from "@beable/roster-backend-client-v1";
import { useEffect, useState } from "react";
import RosterBackendService from "../../../services/RosterBackendService";

export default function useEngagements() {

  const [engagements, setEngagements] = useState<EngagementV1DTO[]>([]);
  const refreshEngagementList = async () => {
    const listEngagementsRequest = await RosterBackendService.listAllEngagements();
    if (listEngagementsRequest.isOk()) {
      const engagementList = listEngagementsRequest.value.map(engagement => ({
        ...engagement,
        schedules: engagement.schedules
          // Make sure any strings are converted to Date objects if set
          .map(schedule =>
          ({
            ...schedule,
            // startAt is non-nullable and required. 
            // In the off chance it somehow is null we will substitute with today's date
            startAt: new Date(schedule.startAt || null),
            endAt: schedule.endAt ? new Date(schedule.endAt) : null
          }))
          // Sort all the individual engagement.schedule records in DESC order
          .sort((a, b) => {
            return (a.startAt && b.startAt) 
              ? b.startAt.getTime() - a.startAt.getTime()
              : -1;
          })
      // Then sort the Engagement list based on the soonest engagement.schedule record
      })).sort((a, b) => {
        if(b.schedules[0]?.startAt && a.schedules[0]?.startAt) {
          return b.schedules[0]?.startAt.getTime() - a.schedules[0]?.startAt.getTime()
        }
        return -1;
      });

      setEngagements(engagementList);
    }
  };

  useEffect(() => {
    refreshEngagementList();
  }, []);

  return { engagements, refreshEngagementList };
}